import { QRCodeQueryParams, fetchQrCode } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { getDeviceToken } from 'app/server/device_token'
import { saveWebDeviceToken } from 'notifications/push'
import { useState } from 'react'
import { Platform } from 'react-native'
import keys from './shared/keys'

export function useQRCode(params: QRCodeQueryParams) {
  const { server } = useServer()
  const [deviceToken, setDeviceToken] = useState<string>()

  const query = useQuery<string>({
    queryKey: [...keys.qr, Platform.OS, params],
    queryFn: fetch,
    enabled: Platform.OS === 'web',
    refetchInterval: 30 * 1000,
  })

  return {
    ...query,
    deviceToken,
  }

  async function fetch() {
    const qrCode = await fetchQrCode(server, params, saveWebDeviceToken)

    try {
      const token = await getDeviceToken()
      setDeviceToken(previous => (previous === token ? previous : token))
    } catch {
      // Keep QR query successful even when reading local device token fails.
    }

    return qrCode
  }
}
